import React, { useState } from 'react'
import { connect } from 'react-redux'
import Scrollbar from 'react-perfect-scrollbar'

// Components Global
import FetchListItems from '../../../../../../components/FetchListItems'

// Component Local
import { OrderItem } from './OrderItem'

// Functions
import { getQueryParams } from '../../../../../../redux/Orders/OrdersFunctions'

// Actions Redux
import { fetchOrders } from '../../../../../../redux/Orders/OrdersActions'


const OrdersListItems = (props) => {
  const [reload, setReload] = useState(false)
  const { business, openSidebar, match, customer } = props
  const forUser = props.params.forUser
  const { status } = match.params
  let { customers_id } = match.params

  if (customer) {
    customers_id = customer._id
  }

  const getParams = () => {
    let params = {}

    if (status === 'all') {
      params = { forUser, name: 'all', title: 'ทั้งหมด', icon: 'library_books' }
    } else if (status === 'contacts') {
      params = { forUser, name: 'contacts', title: 'คำสั่งซื้อใหม่', icon: 'chat' }
    } else if (status === 'unpaid') {
      params = { forUser, name: 'unpaid', title: 'ยังไม่ชำระเงิน', icon: 'assignment_late' }
    } else if (status === 'waiting-confirmed-paid') {
      params = { name: 'waiting-confirmed-paid', title: 'รอยืนยันการชำระเงินจากผู้ขาย', icon: 'gavel' }
    } else if (status === 'partial-paid') {
      params = { forUser, name: 'partial-paid', title: 'ชำระเงินบางส่วน', icon: 'pie_chart' }
    } else if (status === 'prepare-shipping') {
      params = { forUser, name: 'prepare-shipping', title: 'รอการจัดส่งจากผู้ขาย', icon: 'local_shipping' }
    } else if (status === 'shipping-received') {
      params = { forUser, name: 'shipping-received', title: 'ที่ต้องรับ', icon: 'card_giftcard' }
    } else if (status === 'successed') {
      params = { forUser, name: 'successed', title: 'เสร็จแล้ว', icon: 'assignment_turned_in' }
    } else if (status === 'refunded') {
      params = { forUser, name: 'refunded', title: 'คืนเงิน', icon: 'restore_page' }
    } else if (status === 'canceled') {
      params = { forUser, name: 'canceled', title: 'ยกเลิกแล้ว', icon: 'cancel' }
    }

    return params
  }

  const params = getParams()
  const { where, or } = getQueryParams({ params, customers_id, forUser })
  const { title, icon } = params

  const fetchAction = {
    action: fetchOrders,
    actionQuery: {
      authName: params && params.forUser ? 'user' : 'admin',
      dbNo: business.dbNo,
      businesses_id: business._id
    },
    id: business._id,
    where,
    countWhere: where,
    or,
    countOr: or,
    limit: 25,
    sort: '-_id',
    searchAttributes: [
      { name: 'code', options: 'i' },
      { name: 'customer.firstName.local', options: 'i' },
      { name: 'customer.lastName.local', options: 'i' },
      { name: 'customer.firstName.local', join: 'customer.lastName.local', options: 'i' },
      { name: 'customer.mobile.number', options: 'i' },
      { name: 'customer.mobile.code', join: 'customer.mobile.number', options: 'i' },
    ]
  }

  return (
    <div style={{ position: 'absolute', top: '0', left: '0', bottom: '0', right: '0' }}>
      <Scrollbar>
        <FetchListItems
          {...props}
          id="ordersList"
          storeName="orders"
          tableClassName=""
          title={title}
          icon={icon}
          fetchAction={fetchAction}
          componentList={OrderItem}
          columnTitle={{
            column1: 'column col-xxs-12',
            column2: 'column col-xxs-12 pd-top-10'
          }}
          notReloadForUrlChange
          dataReloadForUrlChange={status}
          openSidebar={openSidebar}
        />
      </Scrollbar>
    </div>
  )
}

export default connect()(OrdersListItems)
